import { getAction } from '@/api/manage'

const PLUGIN_API_PREFIX = '/api/plugin/item-detail'

export const getList = (params) => getAction(`${PLUGIN_API_PREFIX}/itemDetail/getList`, params)
